export const SEO_CONFIG = {
  home: {
    getH1: (state) => {
      const currentGameCategory = state.user.currentGameCategory
      const isProduction = process.env.VUE_APP_ENV === 'production'

      if (!currentGameCategory) {
        return '【公式】勝WIN｜オンラインカジノ・オンカジおすすめと最新オンラインパチンコ・パチスロ情報を提供する日本人向け専門サイト'
      }

      const h1ByType = {
        recommend: 'オンカジ・オンラインカジノ',
        new: 'オンカジ・オンラインカジノ',
        popular: 'オンカジ・オンラインカジノ',
        slot: 'オンカジ・オンラインカジノ',
        live_casino: 'オンカジ・オンラインカジノ',
        pachislot: 'オンカジ・オンラインカジノ',
        pachinko: 'オンカジ・オンラインカジノ',
        crash: 'オンカジ・オンラインカジノ'
      }

      const gameTypeNumbers = {
        recommend: isProduction ? 29 : 84,
        new: isProduction ? 1 : 102,
        popular: isProduction ? 30 : 101,
        slot: isProduction ? 13 : 100,
        live_casino: isProduction ? 12 : 87,
        pachislot: isProduction ? 2 : 85,
        pachinko: isProduction ? 14 : 97,
        crash: isProduction ? 6 : 86
      }

      const gameCategoryId = currentGameCategory.id
      const entry = Object.entries(gameTypeNumbers).find(([_, number]) => number === gameCategoryId)

      return entry ? h1ByType[entry[0]] : ''
    },
    getH2: (state) => {
      const currentGameCategory = state.user.currentGameCategory
      const isProduction = process.env.VUE_APP_ENV === 'production'

      if (!currentGameCategory) {
        return []
      }

      const h2ByType = {
        recommend: [],
        new: [],
        popular: [
          'Japanese Speed Baccarat',
          'Moon Princess',
          'Rich Wilde and the Tome of Madness',
          'Rich Wilde and the Tome of Insanity',
          'Sugar Rush 1000',
          'Sweet Bonanza 1000',
          'Crazy Time',
          'Gates of Olympus 1000',
          'Rise Of Olympus 100',
          'Sweet Rush Bonanza'
        ],
        slot: [
          'スロットおすすめ',
          '最新機種',
          'メガウェイズ',
          'ボーナス購入',
          '高配当倍率',
          'ハイボラティリティ',
          '高RTP'
        ],
        live_casino: [
          'ライブカジノ おすすめ',
          'ライブカジノ ポーカー',
          'ライブカジノ ルーレット'
        ],
        pachislot: [
          'パチスロ新台',
          'かぐや様は告らせたい スロット',
          'からくりサーカス スロット',
          'モンハンライズ スロット',
          'ダンベル何キロ持てる スロット',
          'トラブルダークネス スロット',
          '東京リベンジャーズ スロット',
          'ありふれた職業で世界最強 スロット'
        ],
        pachinko: [
          'パチンコ新台',
          'からくりサーカス パチンコ',
          'ブルーロック パチンコ',
          'にゃんこ大戦争 パチンコ',
          '東京グール パチンコ',
          '番長 パチンコ',
          'リゼロ2 パチンコ',
          'まどマギ パチンコ'
        ],
        crash: []
      }

      const gameTypeNumbers = {
        recommend: isProduction ? 29 : 84,
        new: isProduction ? 1 : 102,
        popular: isProduction ? 30 : 101,
        slot: isProduction ? 13 : 100,
        live_casino: isProduction ? 12 : 87,
        pachislot: isProduction ? 2 : 85,
        pachinko: isProduction ? 14 : 97,
        crash: isProduction ? 6 : 86
      }

      const gameCategoryId = currentGameCategory.id
      const entry = Object.entries(gameTypeNumbers).find(([_, number]) => number === gameCategoryId)

      return entry ? h2ByType[entry[0]] : []
    }
  },
  event: {
    getH1: () => '',
    getH2: () => [
      'オンカジ 入金不要ボーナス',
      'ウェルカムボーナス',
      'キャッシュバック',
      'リベートボーナス',
      '昇格ボーナス',
      '誕生日ボーナス',
      '挑戦者求む！スロット50倍当たりチャレンジ',
      '毎日入金W特典日々のプレイがもっと楽しく',
      '毎週最大5万円還元！ウィークリーキャッシュバック'
    ]
  },
  vip: {
    getH1: () => 'オンカジ・オンラインカジノ',
    getH2: () => []
  }
}
